export const CheckCircleFilledIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        className={pathClassName}
        d="M10 3L4.5 8.5L2 6"
        stroke="white"
        strokeWidth="1.6666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};